// extracted by mini-css-extract-plugin
export default {"root":"EnergyUseIntensityChart_root__2NwQK","yUnitLabel":"EnergyUseIntensityChart_yUnitLabel__gYkcK"};